import { helpers } from '@berkshireassociates/berkshirecomponents'
import { date } from 'quasar'
// FORMATTERS
export const berkshireDateStringRules = helpers.date.berkshireDateStringRules
export const toUTCDate = helpers.date.toUTCDate
export const dateAndTime = helpers.date.dateAndTime
export const dateAndTimePrecise = helpers.date.dateAndTimePrecise
export const dashedDate = helpers.date.dashedDate
export const fullDate = helpers.date.fullDate
export const getLocalTimeFromDate = helpers.date.getLocalTimeFromDate
export const convertToISOFormatWithDefaultTime =
  helpers.date.convertToISOFormatWithDefaultTime
export const formatDateStringToISO = helpers.date.formatDateStringToISO
export const formatDateWithSlashesYMD = helpers.date.formatDateWithSlashesYMD
export const projectDataVizDateFormat = (dateString: string) =>
  date.formatDate(dateString, 'MMM DD, YYYY')

// * UTILS
export const getDayDifferenceBetweenDates =
  helpers.date.getDayDifferenceBetweenDates
export const getDayDifferenceFromToday = helpers.date.getDayDifferenceFromToday
export const isTodayOrYesterday = helpers.date.isTodayOrYesterday
export const monthNames = helpers.date.monthNames
export const shortMonthName = helpers.date.shortMonthName
export const convertToSeconds = helpers.date.convertToSeconds
export const isValidDateString = helpers.date.isValidDateString
export const formatDateToMMDDYYYY = helpers.date.formatDateToMMDDYYYY
export const isDateWithinRange = helpers.date.isDateWithinRange
